/**
 * @generated SignedSource<<b9b663fc29199c393898080058f68a5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "scope",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "scopeComponentsScopeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "scopeComponentsScopeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f2784e09dac8240f4a3dc61805e22406",
    "id": null,
    "metadata": {},
    "name": "scopeComponentsScopeMutation",
    "operationKind": "mutation",
    "text": "mutation scopeComponentsScopeMutation(\n  $request: ScopeRequestInput\n) {\n  scope(request: $request) {\n    tokenType\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();

node.hash = "d2672c88dddbb25d4be4fc215106995f";

module.exports = node;
